import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import JBButton from '@jbhi-fi/lanyard-ui/components/Button';
import { styles } from './NotifyMe.css';
import { NotifyMeModal } from '@jbhi-fi/components/src/NotifyMeModal/NotifyMeModal';
import { isFirefoxStrictModeEnabled } from '@jbhi-fi/utils/src/firefoxStrictMode';

type NotifyMeProps = {
  productTitle: string;
  productId: number;
  variantId?: number;
  isProductCard?: boolean;
};

const NotifyMe = ({ productTitle, productId, variantId, isProductCard }: NotifyMeProps): JSX.Element => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  return (
    <>
      {modalVisible
        ? ReactDOM.createPortal(
            <NotifyMeModal
              onClose={() => setModalVisible(false)}
              isOpen={modalVisible}
              productTitle={productTitle}
              productId={productId.toString()}
              variantId={variantId || 0}
            />,
            document.body
          )
        : null}

      {isProductCard ? (
        <button onClick={() => setModalVisible(true)} className={styles.productTileButton}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 18">
            <use xlinkHref="#iconNotifyMe" />
            <title>Notify Me icon</title>
          </svg>
          <span className="visually-hidden">Notify Me</span>
        </button>
      ) : !isFirefoxStrictModeEnabled() ? (
        <JBButton
          data-testid="button-notify-me"
          onClick={() => setModalVisible(true)}
          type="primary"
          classes={styles.button}
          fullWidth
        >
          <span className={styles.notifyMeText}>Notify me</span>
        </JBButton>
      ) : null}
    </>
  );
};

export default NotifyMe;
